import React from 'react';
import cx from 'classnames';
import styles from './DateTime.module.scss';
import DateTimeProps from './DateTime.types';

const displayDate = (ISODateTime, locale, options = {}) => {
  try {
    const d = new Date(ISODateTime);
    return d.toLocaleDateString(locale, options);
  } catch (e) {
    return ISODateTime;
  }
};

const DateTime = ({ ISODateTime, locale, options, className, dataCy }: DateTimeProps) => (
  <time className={cx(styles.dateTime, className)} dateTime={ISODateTime} data-cy={dataCy}>
    {displayDate(ISODateTime, locale || 'en-GB', options)}
  </time>
);

export default DateTime;
